/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Core-owned appearance controls. Persistence and translation belong to the host.
 */
import { useId } from 'react';
import { Icon } from './ComponentIcon';
import './AppearancePreferencesView.css';

export interface AppearancePreferencesViewProps {
  theme: 'light' | 'dark';
  preference: 'system' | 'windows' | 'macos';
  onToggleTheme: () => void;
  onPreferenceChange: (value: 'system' | 'windows' | 'macos') => void;
  labels: { appearance: string; toggleTheme: string; placement: string; system: string; windows: string; macos: string };
}

export function AppearancePreferencesView({ theme, preference, onToggleTheme, onPreferenceChange, labels }: AppearancePreferencesViewProps) {
  const id = useId();
  return (
    <div className="profile-appearance-section" data-tour-id="profile-appearance-preferences">
      <div id={`${id}-label`} className="profile-appearance-label">{labels.appearance}</div>
      <div className="profile-appearance-controls" role="group" aria-labelledby={`${id}-label`}>
        <button type="button" className="profile-theme-toggle" data-tour-id="profile-theme-preference"
          aria-label={labels.toggleTheme} title={labels.toggleTheme} onClick={onToggleTheme}>
          <Icon name={theme === 'light' ? 'darkMode' : 'lightMode'} size={16} />
        </button>
        <select className="profile-modal-control-select" data-tour-id="profile-window-style-preference"
          aria-label={labels.placement} value={preference}
          onChange={event => onPreferenceChange(event.target.value as AppearancePreferencesViewProps['preference'])}>
          <option value="system">{labels.system}</option>
          <option value="windows">{labels.windows}</option>
          <option value="macos">{labels.macos}</option>
        </select>
      </div>
    </div>
  );
}
